const migrations = {
  1: (state) => ({ manager: state.manager }),
};

export default migrations;
